import { Col, Collapse, Form, InputNumber, Row, Select } from 'antd';
import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';

import ClearFilterBtn from '../../../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../../../components/CollapseFilter';
import FilterBtn from '../../../../../../components/FilterBtn';
import FilterContainer from '../../../../../../components/FilterContainer';
import { SelectTransportadoraParceira } from '../../../../../../components/_REFACTORED/SelectTransportadoraParceira';
import { SelectTipoVeiculo } from '../../../../../../components/_REFACTORED/SelectTipoVeiculo';
import TextFilter from '../../../../../../components/TextFilter';
import CollapseTitle from '../../../../../../components/TitleCollapseFilter';
import { ApplicationState } from '../../../../../../store';
import {
  cleanStatateOrdemCaragaPage,
  filterOdemCargaPage,
  loadRequest,
} from '../../../../../../store/ducks/ordemCargaPage/actions';

const { Option } = Select;
const { Panel } = Collapse;

const Filter: React.FC = () => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const pagCurrent = useSelector(
    (state: ApplicationState) => state.OrdemCargaPage.pagination.current
  );
  const sorter = useSelector((state: ApplicationState) => state.OrdemCargaPage.sorter);
  const filter = useSelector((state: ApplicationState) => state.OrdemCargaPage.filter);
  const dispatch = useDispatch<Dispatch<Action>>();

  const clearFilter = () => {
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
    localStorage.removeItem(`responseTiposVeiculosFilter${window.location.pathname}`);
    localStorage.removeItem(`responseTransportadorasFilter${window.location.pathname}`);

    dispatch(cleanStatateOrdemCaragaPage());
    dispatch(loadRequest(undefined, inscricaoAtiva, cddAtivo?.codCdd as number));
  };

  const onFilter = (values: any) => {
    Object.keys(values).forEach((key) => {
      if (values[key] === undefined || values[key] === null || values[key] === '') {
        delete values[key];
      }
    });
    localStorage.setItem(
      window.location.pathname + 'valuesFilter',
      JSON.stringify({ ...filter, ...values })
    );

    dispatch(filterOdemCargaPage({ ...filter, ...values }));
  };

  return (
    <CollapseFilter
      filter={filter}
      pagination={pagCurrent}
      sorter={sorter}
      loadRequest={loadRequest}
      saveFilter={filterOdemCargaPage}
      saveLocalStorage={'persist:OrdemCargaPage'}
    >
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer onFilter={onFilter}>
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Tipo WMS</TextFilter>} name="tipoWms">
                <Select placeholder="Selecione o tipo WMS">
                  <Option value="EXP">Coleta</Option>
                  <Option value="REC">Entrega</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Ordem de carga</TextFilter>} name="ordemCarga">
                <InputNumber
                  type="number"
                  style={{ width: '100%' }}
                  min={0}
                  placeholder="Digite o número da ordem de carga"
                />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectTransportadoraParceira />
            </Col>
            <Col md={6} sm={24} xs={24}>
              <SelectTipoVeiculo />
            </Col>
          </Row>

          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
